var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconWarning({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    enableBackground: "new 0 0 20 20",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F1950A",
    d: "M19.476,16.525L10.699,2.594C10.548,2.354,10.284,2.208,10,2.208S9.452,2.354,9.301,2.594L0.524,16.525 c-0.16,0.254-0.169,0.576-0.024,0.838c0.146,0.264,0.423,0.428,0.723,0.428h17.553c0.302,0,0.578-0.162,0.724-0.428 C19.646,17.102,19.636,16.779,19.476,16.525z M10.051,15.508c-0.576,0-0.96-0.439-0.96-0.963c0-0.553,0.445-0.949,0.96-0.949 c0.551,0,0.971,0.41,0.971,0.949C11.021,15.068,10.626,15.508,10.051,15.508z M11.001,7.62L10.269,12.4H9.832L9.113,7.62 C9.048,7.17,9.1,7.093,9.472,7.093h1.157C11.039,7.093,11.052,7.183,11.001,7.62z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWarning);
export default __webpack_public_path__ + "static/media/icon-warning.5992a941.svg";
export { ForwardRef as ReactComponent };